import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { Enum } from '../../../utility/enum.enum';
import { AppMessage } from './../../../Common/appMessage';
import { AppGlobals } from './../../../Common/Services/app.global';
import { SharedService } from './../../../Common/Services/shared.service';
import { Utility } from './../../../Common/Services/utility';
import { AppConfig } from 'app/Common/appConfiguration';
import { userRole_globalAdmin } from './../../../Common/appConstant';

@Component({
  selector: 'app-adm-update-global-admin',
  templateUrl: './adm-update-global-admin.component.html',
  styleUrls: ['./adm-update-global-admin.component.css'],
})
export class AdmUpdateGlobalAdminComponent implements OnInit {

  globalAdminForm: FormGroup;
  id: number;
  pageConfig: {
    title: string,
    isSaveDisable: boolean,
    isEditDisable: boolean,
    isRetireDisable: boolean
  };

  constructor(private _sharedService: SharedService, public _utility: Utility, private _activatedRoute: ActivatedRoute
    , private _appMessage: AppMessage, private _appGlobal: AppGlobals) {
    this.globalAdminForm = new FormGroup(
      {
        firstName: new FormControl(''),
        lastName: new FormControl(''),
        email: new FormControl('', [Validators.pattern(AppConfig.emailPattern)]),
        contactNo: new FormControl('', [Validators.pattern(AppConfig.phoneNumberRegEx), Validators.required]),
        rhId: new FormControl('', Validators.required)
      })

    this.pageConfig = {
      title: 'Global Administrator',
      isSaveDisable: false,
      isEditDisable: true,
      isRetireDisable: true
    }

    this.globalAdminForm.valueChanges
      .debounceTime(400)
      .subscribe(form => {
        if (!this.globalAdminForm.disabled && this.globalAdminForm.dirty) {
          this._utility.setTxnStatus(true); // display confirm box for FORM changes
        }
      });

  }

  ngOnInit() {
    this._appGlobal.routeWithID = false;
    this._utility.clearTxnStatus(); // close confirm box for FORM changes
    this.setDataOnForm();
  }

  //set data in the form after getting
  setDataOnForm() {
    this.id = this._activatedRoute.snapshot.params['id']; // regional admin Primary Id
    if (this.id == 0) {
      this.pageConfig.title = 'Add ' + this.pageConfig.title;
    } else {
      this.getData();
      this.pageConfig.title = 'Edit ' + this.pageConfig.title;
      this.pageConfig.isSaveDisable = true;
      this.pageConfig.isEditDisable = true;
      this._utility.disableEnableForm(this.globalAdminForm, true);
    }
  }

  // get admin data by id
  getData() {
    let params = "?userRole="+userRole_globalAdmin+"&userId=" + this.id;
    this._utility.addLoaderCount();
    this._sharedService.getUsers(params).subscribe(response => {
      this._utility.onSuccessCallback(response, null, () => {
        let data = response.response.results[0];
        this.globalAdminForm.patchValue(this._utility.manageFormComboData(data));
        if (data.status == Enum.StatusRetire) {
          this.pageConfig.isRetireDisable = true;
          this.pageConfig.isEditDisable = true;
          this.pageConfig.isSaveDisable = true;
        } else {
          this.pageConfig.isRetireDisable = false;
          this.pageConfig.isEditDisable = false;
        }
      });
    }, error => this._utility.onErrorCallback(error));
  }

  //save new record/update existing record
  onSave() {
    let formValues = this.globalAdminForm.getRawValue();
    formValues = this._utility.manageFormDataforSave(formValues);
    formValues.id = this.id;
    this._utility.addLoaderCount();
    this._sharedService.saveAdminDetail(formValues, Enum.RoleTypeGlobalAdmin).subscribe(response => {
      let msg = this.id == 0 ? this._appMessage.getItem['UMsg00030'] : this._appMessage.getItem['UMsg00031'];
      this._utility.onSuccessCallback(response, msg, () => {
        this.pageConfig.isSaveDisable = true;
        this.pageConfig.isEditDisable = false;
        if (this.id == 0) {
          this.pageConfig.isRetireDisable = false; // disable retire button after save new record
        }
        this.id = response.response.id; // set new user Id
        this._utility.disableEnableForm(this.globalAdminForm, true);
        this._utility.clearTxnStatus(); // close confirm box for FORM changes
      });
    }, error => this._utility.onErrorCallback(error));
  }

  //enable save button and form after click on edit
  onEdit() {
    this.pageConfig.isSaveDisable = false;
    this.pageConfig.isEditDisable = true;
    this._utility.disableEnableForm(this.globalAdminForm, false);
  }
  //disable edit option if admin is retired
  onChangeStatus(status : boolean) {
    this._utility.doRetireActiveAdmin(this.id, Enum.RoleTypeGlobalAdmin, status, () => {
      this.pageConfig.isSaveDisable = true;
      this.pageConfig.isEditDisable = !status;
      this.pageConfig.isRetireDisable = !status;
      this._utility.disableEnableForm(this.globalAdminForm, true);
    });
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-global-admin/adm-update-global-admin/adm-update-global-admin.component.ts